import { RestCodes } from "../common/enums/common.enums";
import { IUserClubApplicationDto } from "../common/interfaces/club-application.interface";
import {
  IResendEmailDto,
  ISaveWhitelistingDataDto,
  IUpdateUserAccountDto,
  IUserAccount,
} from "../common/interfaces/user.interface";

import { get, patch, post } from "./utilities/http";
import {
  EMAIL_VERIFICATION_URL,
  USER_APPLICATIONS,
  USERS_BASE_URL,
  SAVE,
  UPDATE,
  WHITELISTING_URL,
} from "./utilities/app.urls";

export async function createUserRequest(
  data: IUserAccount
): Promise<IUserAccount> {
  return await post(USERS_BASE_URL, data);
}

export async function updateUserRequest(
  data: IUpdateUserAccountDto | IResendEmailDto,
  pubkey: string
): Promise<IUserAccount> {
  return await patch(`${USERS_BASE_URL}/${pubkey}`, data);
}

export async function verifyEmailRequest(
  data: any, //TODO@milica: add type
  verificationId: string
): Promise<IUserAccount> {
  return await patch(`${EMAIL_VERIFICATION_URL}/${verificationId}`, data);
}

export async function getUserRequest(pubkey: string) {
  try {
    return await get(`${USERS_BASE_URL}/${pubkey}`);
  } catch (error: any) {
    if (error.response.status === RestCodes.NotFound) {
      return undefined;
    }
    throw error;
  }
}

export async function getUserApplications(
  pubkey: string
): Promise<IUserClubApplicationDto[] | undefined> {
  try {
    return await get(`${USERS_BASE_URL}/${pubkey}/${USER_APPLICATIONS}`);
  } catch (error: any) {
    if (error.response.status === RestCodes.NotFound) {
      return undefined;
    }
    throw error;
  }
}

export async function saveWhitelistingRequest(
  whitelistingData: ISaveWhitelistingDataDto
) {
  return await post(`${WHITELISTING_URL}/${SAVE}`, whitelistingData);
}

export async function updateWhitelistingRequest(
  whitelistingData: ISaveWhitelistingDataDto
) {
  return await patch(`${WHITELISTING_URL}/${UPDATE}`, whitelistingData);
}
